var YEAR_DOM = {
    heightArr: [],
    scrollLocked: false,
    initYearPageHeightList() {
        var dom1 = document.getElementById('yearTopContent');
        var dom2 = document.getElementById('allButtonBox');
        var box1 = document.getElementById('fiveBox');
        var box2 = document.getElementById('talentBox');
        var box3 = document.getElementById('monthBox');
        var box4 = document.getElementById('dayunBox');
        let scrollY = 0, hArr = [];
            // 1
            scrollY = dom1 ? dom1.clientHeight+scrollY : scrollY;
            scrollY = dom2 ? dom2.clientHeight+scrollY : scrollY;
            scrollY -= 15;
            hArr.push(scrollY);
            // 2
            scrollY = box1 ? box1.clientHeight+scrollY : scrollY;
            scrollY += 45;
            hArr.push(scrollY);
            // 3
            scrollY = box2 ? box2.clientHeight+scrollY : scrollY;
            scrollY += 45;
            hArr.push(scrollY);
            // 4
            scrollY = box3 ? box3.clientHeight+scrollY : scrollY;
            scrollY += 55;
            hArr.push(scrollY);
        this.heightArr = hArr;
        // console.log('initYearPageHeightList------', this.heightArr);
    },
    updateYearScrollTopByTab(tabId) {
        var scrollY = 0;
            scrollY = this.heightArr[tabId-1];
        // console.log('scrollY-----', scrollY);
        this.scrollLocked = true;
        setTimeout(() => {
            window.scrollTo({
                left: 0,
                top: scrollY,
                behavior: "smooth",
            });
        }, 20);
        setTimeout(() => {
            this.scrollLocked = false;
        }, 1000);
    },
    bindYearScrollEvent() {
        console.log('bindYearScrollEvent');
        var scrollList = this.heightArr, lastI = scrollList.length-1;
        window.onscroll = function() {
            var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
            for(var i = 0; i < scrollList.length; i++) {
                if(!YEAR_DOM.scrollLocked && scrollY == 0) {
                    AppFate.$bus.emit('updateYearReportTab', 1);
                }else if(!YEAR_DOM.scrollLocked && scrollY > scrollList[i] - 10 && scrollY <= scrollList[i+1]) {
                    AppFate.$bus.emit('updateYearReportTab', i+1);
                }else if(!YEAR_DOM.scrollLocked && i == lastI && scrollY > scrollList[i]) {
                    AppFate.$bus.emit('updateYearReportTab', i+1);
                }
            }
        }
    }
}
export {
    YEAR_DOM
}